<div class="portfolio-kpi-sidepanel-content" *ngIf="selectedKpi as currentKpi">
  <div class="portfolio-kpi-sidepanel-header">
    <ng-container *ngIf="!(isHeaderLoading || isSummaryLoading); else sideHeaderSkeleton">
      <div class="portfolio-kpi-sidepanel-values">
        <span class="portfolio-kpi-sidepanel-secondary-value">{{
          portfolioKpiSecondaryValue
        }}</span>
        <span class="portfolio-kpi-sidepanel-divider">|</span>
        <span class="portfolio-kpi-sidepanel-display-value">{{ portfolioKpiDisplayValue }}</span>
        <span class="portfolio-kpi-sidepanel-divider">|</span>
        <span class="portfolio-kpi-sidepanel-trend">
          <kpi-trend-indicator
            [trendIndicator]="currentKpi.kpi.trendIndicator"
            [trendChange]="currentKpi.kpi.trendChange"
            [kpiType]="currentKpi.kpi.type"
            [kpiName]="currentKpi.kpi.name"
            [showPlaceholder]="true"
          ></kpi-trend-indicator>
        </span>
      </div>

      <div class="portfolio-kpi-sidepanel-status" *ngIf="currentKpi.kpi.health as health">
        <status-badge [type]="'kpiHealth'" [badgeKey]="health"></status-badge>
      </div>
    </ng-container>

    <ng-template #sideHeaderSkeleton>
      <div class="portfolio-kpi-sidepanel-header-skeleton">
        <ngx-skeleton-loader
          class="portfolio-kpi-sidepanel-header-skeleton-values"
          count="1"
          appearance="line"
          [theme]="{
            width: '236px',
            height: '22px',
            'border-radius': '4px',
            display: 'block',
            margin: '0'
          }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          class="portfolio-kpi-sidepanel-header-skeleton-status"
          count="1"
          appearance="line"
          [theme]="{
            width: '98px',
            height: '24px',
            'border-radius': '12px',
            display: 'block',
            margin: '0'
          }"
        ></ngx-skeleton-loader>
      </div>
    </ng-template>
  </div>

  <div class="portfolio-kpi-sidepanel-charts">
    <kpi-chart-card
      [title]="'Average cycle time'"
      [variant]="'side'"
      [cardType]="'cycle'"
      [isLoading]="isCycleLoading"
      [showCycleTooltipText]="true"
      [cycleInfoTitle]="'Average cycle time'"
      [cycleInfoTooltipText]="'Cycle time is the elapsed time from the first milestone’s start to the second milestone’s completion.'"
      [timeCycleChartData]="timeCycleChartData"
      (expandClicked)="openExpandedChart('Average cycle time', 'cycle')"
    ></kpi-chart-card>

    <kpi-chart-card
      [title]="'Milestone status summary'"
      [variant]="'side'"
      [cardType]="'summary'"
      [isLoading]="isSummaryLoading"
      [infoTooltipTitle]="'Milestone status summary'"
      [infoTooltipText]="'KPI tooltip info coming soon.'"
      [milestoneStatusSummaryData]="milestoneStatusSummaryData"
      (summaryStatusClicked)="summaryStatusFilterToggle.emit($event)"
      (expandClicked)="openExpandedChart('Milestone status summary', 'summary')"
    ></kpi-chart-card>
  </div>

  <portfolio-kpi-expanded-panel
    [expanded]="portfolioExpandedPanelExpanded"
    [selectedKpi]="currentKpi"
    [isHeaderLoading]="isHeaderLoading"
    [portfolioExpandedStudiesText]="portfolioExpandedStudiesText"
    [portfolioKpiSecondaryValue]="portfolioKpiSecondaryValue"
    [portfolioKpiDisplayValue]="portfolioKpiDisplayValue"
    [columnTitleMappings]="columnTitleMappings"
    [isCycleLoading]="isCycleLoading"
    [isSummaryLoading]="isSummaryLoading"
    [kpiFiltersApplied]="kpiFiltersApplied"
    [totalKpiFiltersApplied]="totalKpiFiltersApplied"
    [milestoneStatusSummaryData]="milestoneStatusSummaryData"
    [timeCycleChartData]="timeCycleChartData"
    (summaryStatusFilterToggle)="summaryStatusFilterToggle.emit($event)"
    (kpiRemoveFilter)="kpiRemoveFilter.emit($event)"
    (kpiClearAllFilters)="kpiClearAllFilters.emit()"
    (collapsed)="expandedCollapse.emit()"
    (closedAll)="expandedCloseAll.emit()"
  ></portfolio-kpi-expanded-panel>
</div>
